import { EventEmitter, Injectable } from '@angular/core';
import { DestroyableComponent } from '@core/destroyable';

@Injectable()
export class EditableService extends DestroyableComponent {
	static Edit: EventEmitter<void> = new EventEmitter();
	static Save: EventEmitter<void> = new EventEmitter();
	static Cancel: EventEmitter<void> = new EventEmitter();
}
